import { FC } from 'react';
import { Col, Grid, Row } from 'antd';
import {
	TextHeadline,
	ImageSizePriority,
	SpacerSectionTopPadding,
	SpacerSectionInsideColumn,
	SpacerSectionBetweenColumns,
} from 'components';
import { NewsletterInput } from 'components/NewsletterInput/NewsletterInput';
import styles from './SectionHeader.module.css';

export const SectionHeader: FC = () => {
	const { lg } = Grid.useBreakpoint();

	return (
		<Row wrap={!lg} justify={'space-between'}>
			<SpacerSectionTopPadding />
			<Col className={styles.RowMobileCenter} flex={lg && '448px'} lg={26}>
				<h1 className={styles.MobileCenter}>Live Auction</h1>
				<h1 className={styles.MobileCenter}>Coming Soon</h1>
				<p className={styles.MobileCenter}>
					Register with your email address to be notified when the next live
					auction starts.
				</p>
				<SpacerSectionInsideColumn />
				<NewsletterInput />
			</Col>
			<SpacerSectionBetweenColumns />
			<Col flex={!lg && 'auto'}>
				<ImageSizePriority
					primaryPriority={'width'}
					switchBreakpoint={'lg'}
					src={'/assets/live-auction-image.png'}
				/>
			</Col>
		</Row>
	);
};
